class KlantenVertellen {
    url: string;

    constructor(hash: string) {
        this.url = `https://www.klantenvertellen.nl/v1/review/feed.xml?hash=${hash}`;

        // Run immediately
        this.loadFeed();
    }

    loadFeed() {
        $.ajax({
            url: this.url,
            dataType: "xml",
            success: this.handleSuccess.bind(this),
            error: this.handleError.bind(this)
        });
    }

    handleSuccess(xml: XMLDocument) {
        const avg = $(xml).find("last12MonthAverageRating").text();
        const count = $(xml).find("numberReviews").text();

        $(".js-kv-average").text(avg);
        $(".js-kv-reviews").text(count);
    }

    handleError() {
        console.error("Failed to load Klantenvertellen feed.");
    }
}

const kv = new KlantenVertellen("zxode2lwmtbylyj");
